import { AssetFile } from 'contentful';
import NextImage, { ImageLoaderProps } from 'next/image';
import { Source } from '../../../../components/NextImage/Source';
import { ContentfulResizeTypes, getContentfulLoader } from '@lib/images/contentfulLoader';

interface IProps {
  phonePreviewDesktop: AssetFile;
  phonePreviewMobile?: AssetFile;
  phonePreviewTablet?: AssetFile;
}

const ASPECT_RATIO_MOBILE = { width: 3, height: 4 }; // Aspect ratio for mobile 4:3 = 133%
const ASPECT_RATIO_DESKTOP = { width: 2, height: 3 }; // Aspect ratio for desktop 3:2 = 150%

export const CMSChoosePaymentPlanPreviewImage = ({
  phonePreviewDesktop,
  phonePreviewMobile,
  phonePreviewTablet,
}: IProps) => {
  const hasArtDirection = phonePreviewMobile ?? phonePreviewTablet;
  if (!hasArtDirection) {
    return (
      <div className="size-full pb-[150%]">
        <NextImage
          className="w-full object-cover"
          src={phonePreviewDesktop.url}
          fill
          loader={({ src, width, quality }: ImageLoaderProps): string =>
            getContentfulLoader(
              src,
              width,
              ASPECT_RATIO_DESKTOP.width,
              ASPECT_RATIO_DESKTOP.height,
              {
                quality,
                resize: ContentfulResizeTypes.PAD,
              },
            )
          }
          alt="hero image"
          sizes="(min-width: 1680px) 560px, (min-width: 600px) 50vw, 100vw"
        />
      </div>
    );
  }

  return (
    <div className="size-full pb-[133%] sm:pb-[150%]">
      <picture>
        <Source
          loader={({ src, width, quality }: ImageLoaderProps): string =>
            getContentfulLoader(
              src,
              width,
              ASPECT_RATIO_DESKTOP.width,
              ASPECT_RATIO_DESKTOP.height,
              {
                quality,
                resize: ContentfulResizeTypes.PAD,
              },
            )
          }
          media="(min-width: 900px)"
          src={phonePreviewDesktop.url}
          sizes="(min-width: 1680px) 560px, (min-width: 600px) 50vw, 100vw"
        />
        <Source
          loader={({ src, width, quality }: ImageLoaderProps): string =>
            getContentfulLoader(
              src,
              width,
              ASPECT_RATIO_DESKTOP.width,
              ASPECT_RATIO_DESKTOP.height,
              {
                quality,
                resize: ContentfulResizeTypes.PAD,
              },
            )
          }
          media="(min-width: 600px)"
          src={phonePreviewTablet?.url ?? phonePreviewDesktop.url}
          sizes="(min-width: 1680px) 560px, (min-width: 600px) 50vw, 100vw"
        />
        <NextImage
          className="w-full object-cover"
          src={phonePreviewMobile?.url ?? phonePreviewDesktop.url}
          fill
          loader={({ src, width, quality }: ImageLoaderProps): string =>
            getContentfulLoader(src, width, ASPECT_RATIO_MOBILE.width, ASPECT_RATIO_MOBILE.height, {
              quality,
              resize: ContentfulResizeTypes.PAD,
            })
          }
          alt="hero image"
          sizes="(min-width: 1680px) 560px, (min-width: 600px) 50vw, 100vw"
        />
      </picture>
    </div>
  );
};
